
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic02Static as ObiHydraulic02StaticElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-02-static.js';
 
 
 

 
 export const ObiHydraulic02Static = createComponent({
   react: React,
   tagName: 'obi-hydraulic-02-static',
   elementClass: ObiHydraulic02StaticElement,
   events: {
     
   }
  });
 
 